export default __webpack_public_path__ + "static/aws-partner-c0fbc535dbcf1e0a56da0e4a9aed0b17.png";